import { jsx as _jsx } from "react/jsx-runtime";
import { lazy, useEffect } from "react";
import { usePersistState } from "./hooks/usePersistState.js";
import { useIsSSR } from "../routing/hooks/useIsSSR.js";
const DevUI = lazy(() => import("./components/DevUI.js"));
export function DevUILoader() {
    const ssr = useIsSSR();
    const [render, setRender] = usePersistState("enable_devui", false);
    useEffect(() => {
        if (document.location.search.includes("activate-dev-ui") ||
            window["ENABLE_DEV_UI"] ||
            (env.client && env.dev)) {
            setRender(true);
        }
    }, []);
    if (ssr)
        return null;
    if (render) {
        return _jsx(DevUI, {});
    }
    else {
        return null;
    }
}
